module.exports = __webpack_public_path__ + "static/wintermute-d2be6606a6797c3174d3866994982e89.svg";